export interface AttendanceService {
    monthlyFee: number;
    hours: number;
    lunchIncluded: boolean;
    additionalHourFee: number;
    lunchPrice: number;
}
